export const contains = (container, searchTerm) =>
  !!container && container.toUpperCase().includes(searchTerm.toUpperCase());

export function combineOrFilters(...filters) {
  return (data) =>
    filters.reduce((prev, filter) => prev || filter(data), false);
}

export function filterInstancesByName(searchTerm) {
  return (instance) => contains(instance.alias, searchTerm);
}

export function filterInstancesById(searchTerm) {
  return (instance) => contains(instance.flexbox_id, searchTerm);
}

export function filterInstancesByGroupName(searchTerm) {
  return (instance) => {
    const groups = instance?.groups || [];
    return contains(groups[0]?.name || 'Unallocated group', searchTerm);
  };
}

export function matchingId({ id }) {
  return (item) => item.id === id;
}
